import { type OpenLinkOptions, openLink } from "@telegram-apps/sdk-react"

export const openExternalLink = (
	url: string,
	options?: OpenLinkOptions,
): void => {
	if (openLink.isAvailable()) {
		openLink(url, options)
		return
	}

	// Fallback
	let target = "_blank"
	if (options?.tryInstantView) target = "_self"
	window.open(url, target)
}
